<template>
  <div class="fullpage-container">
    <div class="fullpage-wp" v-fullpage="opts" ref="fullPage">
      <div
        class="page-1 page rel bg-center bg-cover"
        style="background-image: url(https://static.wkanx.com/w002/M00/05/E9/CgIXGF6YRXmAKvgsAAAspG89_Qc234.jpg)"
      >
        <Topbar />
        <div class="page-main rel">
          <div class="abs-center-v fs13 color-white inner" style="left: 0.6rem; right: 0.6rem; line-height: 0.24rem">
            <div v-animate="{ value: 'zoomIn' }">
              程序化广告投放平台为客户提供动态广告投放，数据监测，以及广告效果监测与优化。简易操作，即可为不同的广告受众个性化推荐，持续优化推广成本，显著提升转化率
            </div>
            <img
              v-animate="{ value: 'flipInY' }"
              class="db bc m-t-2"
              src="https://static.wkanx.com/w002/M00/05/B3/CgIXGF6ELWSAdJ2PAABLrvnn5lk168.png"
              style="width: 1.15rem"
            />
          </div>
        </div>
        <div class="page-footer">
          <Contact type="info" class="m-b-6" />
          <NextPage type="1" @next="moveNext" />
        </div>
      </div>
      <div class="page-2 page color-primary">
        <Header />
        <div class="page-main tc rfs12 inner">
          <div>适用范围</div>
          <div class="color-default tl" style="margin: 0.25rem 0">
            广告主及代理商，通过投放平台操作投放商品及服务广告，花费大量人力进行创意制作以及精准广告投放，希望有相关工具监测投放效果，持续优化到达率及转化率，尚网网络程序化广告投放平台会是您的不二选择。
          </div>
          <img
            src="https://static.wkanx.com/w002/M00/05/B3/CgIXlV6ELmSAVKKrAABO4t-i4pk500.png"
            style="width: 1.55rem"
          />
        </div>
        <div class="page-footer">
          <Contact class="m-b-2" />
          <NextPage @next="moveNext" />
        </div>
      </div>
      <div class="page-3 page color-primary" style="background: #52b1ff">
        <Header type="2" menuType="light" />
        <div class="page-main color-white rfs12 inner" style="margin: 0 -0.1rem">
          <div class="rfs12 tc" style="padding: 0 0 0.2rem">优秀的技术能力</div>
          <div>
            <div
              v-for="(item, idx) in abilities"
              :key="idx"
              flex="main:start cross:center"
              class="m-b-3"
              v-animate="{ value: 'slideInRight', delay: idx * 30 }"
            >
              <img flex-box="0" :src="item.icon" alt="" style="width: 0.45rem; height: 0.45rem" class="m-r-2" />
              <div class="">
                <div class="fwb">{{ item.title }}</div>
                <div class="rfs9">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-footer">
          <Contact type="info" class="m-b-2" />
          <NextPage type="1" @next="moveNext" />
        </div>
      </div>
      <div class="page-4 page color-primary">
        <Header />
        <div class="page-main tc rfs12">
          <div class="tc" style="margin: 0 0 0.15rem">使用教程下载</div>
          <div class="tl color-default">
            从创建账号，数据输入到准备创意模板，及最终投放方式直至最终生成广告的全流程说明
          </div>
          <div class="color-default bc rel" style="width: 1.6rem">
            <div flex="main:justify cross:bottom" class="m-t-4 p-t-2 rel">
              <div class="tutorial-step" v-animate="{ value: 'flipInY', delay: 0 }">
                <img src="https://static.wkanx.com/w002/M00/05/B3/CgIXlV6EOKaAAGD8AAADRcOxrDU175.png" width="31" />
                <div class="m-t-1">创建账号</div>
              </div>
              <img
                class="abs-center-h"
                style="width: 0.55rem; top: 0.25rem"
                src="https://static.wkanx.com/w002/M00/05/E9/CgIXlV6YS7qAGk-cAAABipMV7Pc671.png"
              />
              <div class="tutorial-step" v-animate="{ value: 'flipInY', delay: 50 }">
                <img src="https://static.wkanx.com/w002/M00/05/B3/CgIXgV6EOYSAAtvFAAACLaUhbvY994.png" width="32" />
                <div class="m-t-1">数据接入</div>
              </div>
            </div>
            <img
              class="abs-center-v arrow2"
              style="width: 0.55rem; right: 0"
              src="https://static.wkanx.com/w002/M00/05/E9/CgIXlV6YS7qAGk-cAAABipMV7Pc671.png"
            />
            <div flex="main:justify cross:bottom" class="m-t-6 p-t-2 rel">
              <div class="tutorial-step" v-animate="{ value: 'flipInY', delay: 100 }">
                <img src="https://static.wkanx.com/w002/M00/05/B3/CgIXlV6EOZWAXGgUAAABNJcNvC8709.png" width="33" />
                <div class="m-t-1">创意模板</div>
              </div>
              <img
                class="abs-center-h arrow3"
                style="width: 0.55rem; top: 0.25rem"
                src="https://static.wkanx.com/w002/M00/05/E9/CgIXlV6YS7qAGk-cAAABipMV7Pc671.png"
              />
              <div v-animate="{ value: 'flipInY', delay: 150 }">
                <img src="https://static.wkanx.com/w002/M00/05/B3/CgIXlV6EOZyANw-OAAACNf5aOzM364.png" width="31" />
                <div class="m-t-1">投放方式</div>
              </div>
            </div>
          </div>
          <a class="db bc m-t-6" href="/WiFi万能钥匙广告投放平台基本功能介绍.pdf" target="_blank">
            <van-button class="bc" type="primary">教程下载</van-button>
          </a>
        </div>
        <Contact class="page-footer" />
      </div>
    </div>
  </div>
</template>
<script>
import Base from './Base';

export default {
  name: '',
  props: {},
  extends: Base,
  data() {
    return {
      abilities: [
        {
          icon: 'https://static.wkanx.com/w002/M00/05/B3/CgIXgV6ENS2AU1kGAAAEwpOj6iE439.png',
          title: 'WiFi DMP',
          desc:
            'WiFi DMP 是连接自有用户数据和广告投放数据的桥梁，已全面支持三方数据。它能实现老用户在 WiFi 的追投、唤醒、复购、 拓展等多种营销活动，让推广精准触达，最大化数据价值，提升营销效果。 ',
        },
        {
          icon: 'https://static.wkanx.com/w002/M00/05/B3/CgIXGF6ENSmAeId0AAAFcThDewM075.png',
          title: '更精准的用户触达',
          desc:
            '从创意制作开始帮助客户不断持续优化，并为用户提供转化追踪、智能自动调整创意及投放等相关策略优化，帮助客户更精准覆盖及触达更多目标人群',
        },
        {
          icon: 'https://static.wkanx.com/w002/M00/05/B3/CgIXgV6ENR-AGt9mAAAEGrmkj_0501.png',
          title: '智能出价',
          desc:
            '基于oCPC技术，以转化目标为优化目的的点击出价，计费方式为按点击计费帮助客户基于目标转化维度的智能出价优化',
        },
        {
          icon: 'https://static.wkanx.com/w002/M00/05/B3/CgIXgV6ENROAMVyeAAAEyjLRx80473.png',
          title: '多维度商品推荐',
          desc:
            '基于动态商品广告DPA技术，广告主一次对接结构化商品信息，利用商品数据批量生成海量创意，进行千人千面投放，以进行维度的精准广告推荐',
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang='scss' scoped>
.page-4 {
  .arrow2 {
    transform: rotate(90deg);
  }
  .arrow3 {
    transform: rotate(180deg) translate(50%, 0);
  }
}
.tutorial-step {
  position: relative;
  background: white;
  z-index: 1;
}
</style>
